import React, { useCallback } from "react";
import FormGroup from "react-bootstrap/lib/FormGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import { getLocalizedText } from "data/utils";

const Control = ({ classNames = [], keep, setKeep }) => {
    const [group, checkbox, label] = classNames;
    const handleKeepFilename = useCallback(
        (e: SyntheticEvent<HTMLInputElement>) => {
            setKeep(!keep);
        },
        [setKeep, keep]
    );
    return (
        <FormGroup controlId="keepFilename" className={group}>
            <FormControl
                type="checkbox"
                name="keepFilename"
                className={checkbox}
                checked={keep}
                onChange={handleKeepFilename}
            />
            <ControlLabel
                className={label}
                title={getLocalizedText("$upload:keepFilename")}
            >
                {getLocalizedText("$upload:keepFilename")}
            </ControlLabel>
        </FormGroup>
    );
};

Control.displayName = "KeepFilename.Control";

export default Control;
